import data from "../../../../../src/Breadcrumbs.docs.json";
import * as React from 'react';
export default {
  data,
  React
};